import { NavLink } from 'react-router';

import { Button } from 'ui';
import { AcceptIconTeacherActive } from 'ui/icons/Accept.Icon';

import styles from '../DetailsProfile/DetailsProfile.module.scss';

interface HeaderDetailsProfileProps {
  avatar: string;
  fullName: string;
  age: number;
  gender: string;
  price: string;
}

export const HeaderDetailsProfile = ({
  avatar,
  fullName,
  age,
  gender,
  price,
}: HeaderDetailsProfileProps) => (
  <div className={styles['profile-card__item-header']}>
    <div className={styles['profile-card__item-header-avatar']}>
      <img src={avatar} alt='avatar' />
      <h1>{fullName}</h1>
      <AcceptIconTeacherActive />
    </div>

    <div className={styles['profile-card__item-header-content']}>
      <div className={styles['profile-card__item-header-content-info']}>
        <p>
          {age} лет, {gender}
        </p>
        <span>{price}</span>
      </div>
      <NavLink style={{ textDecoration: 'none' }} to={'/profile/details/rep'}>
        <Button color='primary' size='md' shape='brick'>
          Профиль репетитора
        </Button>
      </NavLink>
    </div>
  </div>
);
